import React, { Fragment, lazy, Suspense } from 'react';
import './App.css';
import { QRCodeCanvas } from 'qrcode.react';
import { api } from './Module';
import Login from "./Login";

// END KEAGAMAAN
class Main extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      Profile: {},
      Token: "",
      DataPengunjung: [],
      DataBuku: []
    };
  }

  async componentDidMount() {
    let profile = await api("controler/profile_api", { act: "data profile" }, true);
    if (profile.status == "sukses") {
      document.title = "Sistem akademin " + profile.data.Nama;
      document.getElementById('linkIconHeader').href = 'https://apis.naylatools.com/' + profile.data.Logo;
      document.getElementById('linkIcoHeader').href = 'https://apis.naylatools.com/' + profile.data.Logo;
      document.documentElement.style.setProperty('--color-primary', profile.data.ColorDefault);
      this.setState({ Profile: profile.data }, async () => {
        let sql = await api("scan", { act: "buat token", TokenType: "masuk perpus" });
        if (sql.status == "sukses") {
          this.setState({ Token: sql.token })
        } else {
          alert(sql.pesan);
        }

        let Buku = await api("controler/perpus_api", { act: "data promo buku" });
        if (Buku.status == "sukses") this.setState({ DataBuku: Buku.data });

        let Data = await api("controler/perpus_api", { act: "data pengungjung real" });
        if (Data.status == "sukses") this.setState({ DataPengunjung: Data.data });

        setInterval(async () => {
          let Data = await api("controler/perpus_api", { act: "data pengungjung real" });
          if (Data.status == "sukses") this.setState({ DataPengunjung: Data.data });
        }, 10000);
      });
    }
  }



  render() {
    return (
      <Fragment>
        <header><img src={'https://apis.naylatools.com/' + this.state.Profile.Logo} style={{ width: "75px" }} /> PERPUSTAKAAN {this.state.Profile.Nama} — HALAMAN PENGUNJUNG</header>
        <main>
          <section className="left">
            <div className="qrcode">
              <img src={`https://api.qrserver.com/v1/create-qr-code/?size=260x260&data=${this.state.Token}`} alt="QR Code" />
            </div>

            <div className="visitor-list">
              <h3>👥 Pengunjung Hari Ini</h3>
              {
                this.state.DataPengunjung.map((item, i) => {
                  return <div className="visitor-item">{i + 1}. {item.NamaAnggota} <span>— {item.TimeCreated.substring(10)}</span></div>
                })
              }
            </div>
          </section>

          <section className="right">
            <h3>📖 Buku Highlight Minggu Ini</h3>
            <div className="highlight-list">
              {
                this.state.DataBuku.map((item, i) => {
                  return (
                    <div className="book-card" key={i}>
                      <img src={"https://apis.naylatools.com/" + item.Foto} alt="Book" />
                      <div className="book-title">{item.Judul}</div>
                      <div className="book-author">{item.Sinopsis}</div>
                    </div>
                  )
                })
              }
            </div>
          </section>
        </main>

        <footer>© 2025 Perpustakaan Maduwa | Sistem Informasi Pengunjung</footer>
      </Fragment>
    );
  }
}

export default function App() {
  let Token = localStorage.getItem("TokenAdmin");
  if (Token) {
    return <Main />
  } else {
    return <Login />
  }
}